import { useDispatch, useSelector } from "react-redux";
import Styles from "./Lock.module.css";
import { useEffect, useState } from "react";
import { ListOrders } from "../Action/OrderPackageAction";
import { Link } from "react-router-dom";
export default function Lock({ texts }) {
  const dispatch = useDispatch();
  const [OrderSuccess, setOrderSuccess] = useState(false);
  const { OrdersRec } = useSelector((s) => s.ListOrdersReducer);

  useEffect(() => {
    dispatch(ListOrders());
  }, [dispatch]);

  useEffect(() => {
    for (let i = 0; i < OrdersRec?.length; i++) {
      if (
        OrdersRec[i]?.transactionStatus == "Success" &&
        OrdersRec[i]?.Amount != 99
      ) {
        setOrderSuccess(true);
      }
    }
  }, [OrdersRec]);

  return (
    <>
      <div className={Styles.Lock_Container}>
        {/* <div>
          <img src="/assets/image/Lock.png" alt="Lock logo" />
        </div> */}
        {texts ? (
          <div className={Styles.content}>
            <div className={Styles.accesstext}>{texts}</div>
          </div>
        ) : (
          <>
            {OrderSuccess ? (
              <div className={Styles.content}>
                <div className={Styles.accesstext}>
                  Access will be granted within 24 hours
                </div>
                <div className={Styles.note}>
                  You’ll receive full access to all features soon.
                </div>
              </div>
            ) : (
              <div className={Styles.content}>
                <div className={Styles.accesstext}>
                  Please <Link to="/student/support">contact us </Link> to
                  unlock this section.
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
